<div class="backdrop"  (click)="closed.emit()">
    <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="pm-title" (click)="$event.stopPropagation()">
        <header>
            <h2 id="pm-title">Print preview</h2>
            <button type="button" class="icon" aria-label="Close preview" (click)="closed.emit()">×</button>
        </header>

        <div class="stage">
            <article class="sheet">
                <h3>{{ title }}</h3>
                <p class="meta">{{ today }} · {{ rows.length }} {{ rows.length === 1 ? 'row' : 'rows' }}</p>

                <div class="scroll">
                    <table>
                        <thead>
                            <tr>
                                @for(c of columns; track $index){
                                    <th [style.text-align]="c.align || 'left'">{{ c.header }}</th>
                                }                                
                            </tr>

                        </thead>
                        <!-- <tbody>
                            <tr *ngFor="let r of rows">
                                <td *ngFor="let c of columns" [style.text-align]="c.align || 'left'">{{ cell(r, c) }}
                                </td>
                            </tr>
                            <tr *ngIf="!rows.length">
                                <td [attr.colspan]="columns.length" class="empty">No data to print.</td>
                            </tr>
                        </tbody> -->

                        <tbody>
                            @for(r of rows; track r.id){
                                <tr>
                                    @for(c of columns; track $index){
                                    
                                        <td  [style.text-align]="c.align || 'left'">
                                            {{ cell(r, c) }}
                                        </td>
                                    
                                    }
                                </tr>
                            }
                            <tr *ngIf="!rows.length">
                                <td [attr.colspan]="columns.length" class="empty">No data to print.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </article>
        </div>

        <footer>
            <button type="button" class="btn" (click)="closed.emit()">Cancel</button>
            <button type="button" class="btn primary" #printBtn [disabled]="!rows.length"
                (click)="print()">Print</button>
        </footer>
    </div>
</div>